import moment from "moment";
import Utils from "@/utils";
import { ProjectType } from "@/models/project/project-type";
import ISetting from "@/interfaces/setting";
import Request from "@/models/checkRequest/request";

export default class Project {
  id: string;
  dateCreated: string;
  name: string;
  description: string;
  requests: Array<Request>;
  settings: Array<ISetting> = [];
  type: ProjectType;

  isReadOnly: boolean;
  isBusy: boolean;

  useOnByOne: boolean;

  constructor() {
    this.id = Utils.GenerateUniqueId();
    this.name = "";
    this.description = "";
    this.dateCreated = moment().toString();
    this.requests = [];
    this.type = ProjectType.Basic;
    this.useOnByOne = false;
    this.isBusy = false;
    this.isReadOnly = false;
  }

  get completedRequests(): number {
    return this.requests.filter((r) => r.isReady).length;
  }

  get percentageComplete(): number {
    if (this.completedRequests > 0) {
      return Math.floor((this.completedRequests * 100) / this.requests.length);
    }

    return 0;
  }

  get isCompleted(): boolean {
    if (this.requests.length <= 0) return false;

    return this.completedRequests === this.requests.length;
  }
}
